export default "__VITE_ASSET__eIXGmuDF__"